module.exports = __webpack_public_path__ + "static/media/synagogue.456786f0.svg";